import React,{ useState, useEffect, useRef } from 'react';
import { Drawer, Col, Row } from 'antd';
import { CloseOutlined  } from '@ant-design/icons';

import CardDom from '../CardDom/CardDom';


const PhotoWall = ({PhotoWallData}) =>{
  const [selectExpert, setSelectExpert] = useState({})
  const [openDrawer, setOpenDrawer] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])
  if(width > 770){
    return (
      <div style={{borderTop: '1px solid rgba(0,0,0,0.08)',borderBottom: '1px solid rgba(0,0,0,0.08)', marginTop: '50px'}}>
        <div style={{width: '100%', maxWidth: 1440, margin: '0 auto 50px'}}>
          <div style={{display:'flex', justifyContent: 'space-between',alignItems:'center', padding: '50px 0'}}>
            <div style={PhotoWallData.description? {width: '40%'}:{width: '100%'}}>
              <div style={{fontSize: PhotoWallData.subTitleSize}}>{PhotoWallData.subTitle}</div>
              <div style={{fontSize: PhotoWallData.titleSize}}>{PhotoWallData.title}</div>
            </div>
            <div style={{width: '40%', fontSize: PhotoWallData.descriptionSize}}>{PhotoWallData.description}</div>
          </div>
          
          {PhotoWallData.subTitle2 && <div style={{ fontSize: 'clamp(18px, calc(16.94px + 0.28vw), 21px)', borderTop: '1px solid #272724', padding:'15px 0 50px'}}>{PhotoWallData.subTitle2}</div>}
          
          <Row>
            {PhotoWallData.data.map((e,i)=>{
              return (
                <Col 
                  span={4} 
                  key={i}
                  style={{marginRight: 20, cursor: 'pointer'}}
                  onClick={()=> {
                    // console.log(e)
                    if(PhotoWallData.drawer){
                      setOpenDrawer(true);
                      setSelectExpert(()=> e.content)
                    }
                  }}
                >
                  <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                </Col>
              )
            })}
          </Row>
        </div>
        {/* 专家详情 */}
        {PhotoWallData.drawer && <Drawer width={'70%'} onClose={()=> setOpenDrawer(false)} open={openDrawer} closeIcon={false} destroyOnClose={true}>
          <div style={{padding: 'clamp(40px, calc(37.18px + 0.75vw), 48px)'}}>
            <div style={{display:'flex',justifyContent:'space-between'}}>
              <div style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'}}>
                <span style={{marginRight: 10,fontWeight: 600}}>科学</span> 
                科学和临床顾问
              </div>
              <CloseOutlined onClick={()=> setOpenDrawer(false)}/>
            </div>
  
            <div style={{display:'flex',justifyContent:'space-between', marginTop: 80}}>
              <div style={{width: '35%', fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)'}}>
                <div>{selectExpert.title}</div>
                <div style={{color: 'rgba(0,0,0,0.54)', margin: '10px 0 50px'}}>{selectExpert.subTitle}</div>
                {selectExpert.top}
              </div>
              <div style={{width: '60%', fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'}}>{selectExpert.description}</div>
            </div>
          </div>
        </Drawer>}
      </div>
    )
  }else{
    return (
      <div style={{borderTop: '1px solid rgba(0,0,0,0.08)',borderBottom: '1px solid rgba(0,0,0,0.08)', marginTop: '50px'}}>
        <div style={{width: '100%', maxWidth: 1440, margin: '0 auto 50px'}}>
          <div style={{ padding: '50px 25px'}}>
            <div style={{width: '100%'}}>
              <div style={{fontSize: PhotoWallData.subTitleSize}}>{PhotoWallData.subTitle}</div>
              <div style={{fontSize: PhotoWallData.titleSize}}>{PhotoWallData.title}</div>
            </div>
            <div style={{fontSize: PhotoWallData.descriptionSize}}>{PhotoWallData.description}</div>
          </div>
          
          {PhotoWallData.subTitle2 && 
            <div style={{ fontSize: 'clamp(18px, calc(16.94px + 0.28vw), 21px)', borderTop: '1px solid #272724', padding:'15px 25px 50px'}}>
              {PhotoWallData.subTitle2}
            </div>
          }
          
          <div style={{padding:'0 25px'}}>
            <Row gutter={[16, 16]}>
              {PhotoWallData.data.map((e,i)=>{
                return (
                  <Col 
                    span={12} 
                    key={i} 
                    onClick={()=> {
                      // console.log(e)
                      if(PhotoWallData.drawer){
                        setOpenDrawer(true);
                        setSelectExpert(()=> e.content)
                      }
                    }}
                  >
                    <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                  </Col>
                )
              })}
            </Row>
          </div>
        </div>
        {/* 专家详情 */}
        {PhotoWallData.drawer && 
          <Drawer width={'100%'} onClose={()=> setOpenDrawer(false)} open={openDrawer} closeIcon={false} destroyOnClose={true}>
            <div style={{padding: 24}}>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <div style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)'}}>
                  <span style={{marginRight: 10,fontWeight: 600}}>科学</span> 
                  科学和临床顾问
                </div>
                <CloseOutlined onClick={()=> setOpenDrawer(false)}/>
              </div>

              <div style={{ marginTop: 60 }}>
                <div style={{ fontSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)'}}>
                  <div>{selectExpert.title}</div>
                  <div style={{color: 'rgba(0,0,0,0.54)', margin: '10px 0 50px'}}>{selectExpert.subTitle}</div>
                  {selectExpert.top}
                </div>
                <div style={{ fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)', marginTop: 30}}>{selectExpert.description}</div>
              </div>
            </div>
          </Drawer>
        }
      </div>
    )
  }
}

export default PhotoWall